import type {
  ActivityBookableOption,
  ActivityIngredientAdapter,
  ActivityIngredientResponse,
} from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';
import { isDefined } from '@libs/utils';

import { assertSmartSearchValue } from '../../utils';

import type { IngredientResponseQL } from './itineraryResponseQL';
import { toMoney } from './moneyResponseQL';

type IngredientWithSubIngredientResponseQL = Extract<
  IngredientResponseQL,
  { subIngredientResults?: unknown }
>;
type SubIngredientResponsesQL = NonNullable<
  IngredientWithSubIngredientResponseQL['subIngredientResults']
>;
type SubIngredientResponseQL = NonNullable<SubIngredientResponsesQL[number]>;
type ActivityIngredientResponseQL = Extract<
  SubIngredientResponseQL,
  { type: 'TicketIngredientResponseQL' }
>;
export function toActivityIngredientResponse(
  result: ActivityIngredientResponseQL,
  ingredient: ActivityIngredientAdapter
): ActivityIngredientResponse {
  assertSmartSearchValue(result.date);

  const suggested: ActivityBookableOption | null =
    isDefined(result.code) && isDefined(result.totalPrice)
      ? {
          code: result.code,
          totalPrice: toMoney(result.totalPrice),
          addToBasketToken: '',
        }
      : null;

  return {
    ingredientId: ingredient.parentIngredientId,
    ingredientType: IngredientType.Activity,
    date: new Date(result.date),
    options: [],
    subIngredientResponse: [],
    suggested,
    isAvailable: !!result.totalPrice,
  };
}
